import {Form, DropdownButton, Dropdown} from 'react-bootstrap';
import LabelComponent from "./LabelComponent.js";

export default function FormDropDownComponent({
  formId = "dropdownbutton", 
  label="", 
  labelIcon="", 
  title = "", 
  data=[],
  onSelect = () => {},
  id = 0,
  variant="primary"
  }) {
  function getTitle() {
    if(id || id === 0) {
      const option = data.filter( (obj) => obj.id === id )[0];
      if(option) {
        return option.label;
      }
    } else {
      return title;
    }
  }

  return (
    <Form.Group>
        <LabelComponent 
          label={label}
          labelIcon={labelIcon}
        />
        <DropdownButton
            id={formId}
            title={getTitle()}
            onSelect={onSelect}
            key={formId}
            variant={variant}
        >
          {
          data.length > 1
          ?
            data.map( (row, index) => {
              if(row.id === 0 && data.length === 2) {
                return false;
              }
              return <Dropdown.Item as="button" eventKey={row.id} key={row.id}>{row.label}</Dropdown.Item>
            })
          :
            <Dropdown.Item as="button" eventKey={0} disabled>No records</Dropdown.Item>
          }
        </DropdownButton>
    </Form.Group>
  );
}